import { Component, Input, OnInit } from '@angular/core';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-day-break',
  templateUrl: './route-itinerary-day-break.component.html',
  styleUrls: [
    './route-itinerary-day-break.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
  standalone: true,
  imports: [VmePipesModule, CommonModule],
})
export class RouteItineraryDayBreakComponent {
  @Input() currentDayNumber: number;
  @Input() totalDays: number;
  @Input() dayDate: string;
  @Input() isCarryoverDay: boolean = false;
  @Input() fullWidth: boolean = false;

  constructor() {}
}
